import { render, staticRenderFns } from "./Typologies.vue?vue&type=template&id=e0544528&scoped=true"
import script from "./Typologies.vue?vue&type=script&lang=js"
export * from "./Typologies.vue?vue&type=script&lang=js"
import style0 from "./Typologies.vue?vue&type=style&index=0&id=e0544528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0544528",
  null
  
)

export default component.exports